import type { FC } from 'react';
import MdcLogoWhite from './MdcLogoWhite';
import styles from './styles.module.scss';

type Size = 'small' | 'medium' | 'large';

interface Props {
  size?: Size;
  /**
   * Announced by screen readers. Every caller today is a loading indicator, hence the default.
   */
  label?: string;
}

/** Box the logo itself is drawn into, in CSS pixels. */
const SIZES = {
  small: { width: 23, height: 15, strokeWidth: 2 },
  medium: { width: 33, height: 21, strokeWidth: 3 },
  large: { width: 53, height: 33, strokeWidth: 4 },
} as const;

/** Breathing room around the logo that turns the wrapper into the surrounding disc. */
const DISC_PADDING = 20;

export const AnimatedLogo: FC<Props> = ({ size = 'medium', label = 'Loading' }) => {
  const { width, height, strokeWidth } = SIZES[size];
  const disc = width + DISC_PADDING;

  return (
    <div className={styles.wrapper} style={{ width: disc, height: disc }} role="img" aria-label={label}>
      <MdcLogoWhite height={height} width={width} strokeWidth={strokeWidth} />
    </div>
  );
};
